import * as Yup from 'yup';
//^(0|[1-9]\d*)$
export const validacionBusqueda = Yup.object({
    fecha: Yup.string(),
    forma_pago: Yup.string().required('Campo obligatorio'),
    id_caja: Yup.string().required('Campo obligatorio'),
    estado: Yup.string().required('Campo obligatorio'),
    concepto:  Yup.string().required('Campo obligatorio'),
    tipo_consulta: Yup.string().required('Campo obligatorio'),
    cantidad: Yup.string().matches(/^[1-9]\d*$/, "Solo números enteros").required('Campo obligatorio'),
    costo: Yup.string().required('Campo obligatorio'),
    foranea: Yup.boolean(),
});

export const validacionOtrosConceptos = Yup.object({
    fecha: Yup.string(),
    forma_pago: Yup.string().required('Campo obligatorio'),
    id_caja: Yup.string().required('Campo obligatorio'),
    movimiento : Yup.string().required('Campo obligatorio'),
    factura : Yup.string(),
    observaciones : Yup.string(),
    monto : Yup.string().matches(/^(0|[1-9]\d*)(\.\d+)?$/, "Solo números").required('Campo obligatorio')
});

export const validacionesCorteCaja = Yup.object({
    fecha: Yup.string(),
    id_caja: Yup.string().required('Campo obligatorio'),
    d1000: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d500: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d200: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d100: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d50: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d20: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d10: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d5: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d2: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
    d1: Yup.number().typeError('Solo números').integer('Números enteros').min(0, 'Números positivos o cero'),
});

export const validacionesTransferencia = Yup.object({
    fecha: Yup.string(),
    id_caja : Yup.string().required('Campo obligatorio'),
    id_caja_destino: Yup.string().required('Campo obligatorio'),
    monto: Yup.string().matches(/^(0|[1-9]\d*)(\.\d+)?$/, "Solo números").required('Campo obligatorio'),
    recibio: Yup.string().required('Campo obligatorio'),
    observaciones: Yup.string(),
});
